import { clsx } from 'clsx'
import { useState } from 'react'
import { initials } from './initials'

type Props = {
  name: string
  src?: string | null
  size?: 'sm' | 'md' | 'lg'
  /** On a dark surface (the console header): light ring and initials. */
  inverse?: boolean
  className?: string
}

const SIZES = { sm: 'h-8 w-8 text-[0.6875rem]', md: 'h-10 w-10 text-small', lg: 'h-20 w-20 text-h4' }

/** A person's photo in a circle, or their initials when there isn't one (or it fails to load). */
export function Avatar({ name, src, size = 'sm', inverse, className }: Props) {
  const [failed, setFailed] = useState<string | null>(null)
  const show = src && failed !== src
  return (
    <span
      aria-hidden="true"
      className={clsx(
        'inline-grid shrink-0 place-items-center overflow-hidden rounded-full font-medium tracking-wide',
        SIZES[size],
        inverse ? 'bg-paper/15 text-paper ring-1 ring-paper/30' : 'bg-gray-100 text-charcoal ring-1 ring-gray-200',
        className,
      )}
    >
      {show ? <img src={src} alt="" referrerPolicy="no-referrer" className="h-full w-full object-cover" onError={() => setFailed(src)} /> : initials(name) || '·'}
    </span>
  )
}
